import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { ModalConfig } from 'src/app/core/models/modalConfig';
import { AlertAndNotificationsService } from 'src/app/core/services/alert-and-notifications.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { CandidateService } from 'src/app/core/services/candidate.service';
import { AngularModalService } from 'src/app/core/services/modal.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UserService } from 'src/app/core/services/user.service';
import { UserCardActionsModalComponent } from './user-card-actions-modal/user-card-actions-modal.component';

@Component({
  selector: 'app-user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.css']
})
export class UserCardComponent implements OnInit {

  @Input() userInfo: any;
  @Input() managers: any;
  @Input() activityMap: any;
  @Input() isUserRowViewActive: boolean;
  @Output() deleteUserCallback = new EventEmitter<any>();

  userCardActionsModal: BsModalRef;
  imageUrl: any;
  companyState: any;
  companyType: any;
  notCurrentUser: boolean;
  showRecentActivitiesFlag: boolean = true;
  isActivityClicked: boolean = false;
  showUserScope: boolean = false;
  isUserScope: boolean = false;
  recentActivitiesControls: any = {};
  clientOrBuList: any[] = [];
  deletingUser: any;

  constructor(
    public authService: AuthService,
    private userService: UserService,
    private candidateService: CandidateService,
    private alertsAndNotificationsService: AlertAndNotificationsService,
    private angularModalService: AngularModalService,
    private modalService: BsModalService,
    private storageService: StorageService,
    public $state: StateService
  ) { }

  ngOnInit() {
    this.recentActivitiesControls.getActivities = null;
    this.recentActivitiesControls.activityClickCount = 0;
    this.imageUrl = this.authService.getUserDetails().imageUrl || '';
    this.companyState = this.authService.getUserDetails().company.companyState;
    this.companyType = this.authService.getUserDetails().company.companyType;
    this.notCurrentUser = this.userInfo.userId !== this.authService.getUserDetails().id;

    if (_.isUndefined(this.activityMap)) {
      this.activityMap = [];
    }

    this.userInfo.name = this.userInfo.name
      ? this.userInfo.name
      : (this.userInfo.firstName + ' ' + this.userInfo.lastName);

    if (!this.isUserRowViewActive) {
      this.getCandidatesCount();
    }

    this.userInfo.isUserVerified =
      this.userInfo.userState !== 'UnVerfied' && this.userInfo.userState !== 'PasswordReset';
    this.userInfo.userVerifiedMessage = this.userInfo.isUserVerified ? '' : 'UnVerified';

    this._setClientOrBUList();
  }

  viewReportees(teamMember) {
    this.managers.push(teamMember);
    this.storageService.set('managers', this.managers, null);
    this.$state.go('missioncontrol.teamMembers',
      { managerObj: teamMember, userType: 'applicationUsers', fromManagerCard: true },
      { reload: true });
  }

  getCandidatesCount() {
    this.userInfo.isLoadingCounts = true;
    this.userInfo.passiveCandidatesCount = 0;
    this.userInfo.activeCandidatesCount = 0;
    this.candidateService.getCandidatesCount(
      this.authService.getUserDetails().company.companyId,
      this.userInfo.userId,
      (data) => {
        this.userInfo.isLoadingCounts = false;
        this.userInfo.passiveCandidatesCount = data.passiveCandidatesCount;
        this.userInfo.activeCandidatesCount = data.activeCandidatesCount;
      },
      (error) => {
        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
      });
  }

  viewProfile(user, accessMode) {
    this.storageService.set('managers', this.managers, null);
    setTimeout(() => {
      this.$state.go('missioncontrol.usermanagement',
        { userId: user.userId, accessMode: accessMode },
        { reload: false });
    }, 500);
  }

  deleteSelectedUser(user) {
    this.deletingUser = user;
    this.getDeleteUserInfo(user.userId);
  }

  resendInvite(user) {
    this.alertsAndNotificationsService.showConfirm(
      'Confirm',
      'Are you sure you want to resend invite to the user?',
      'warning',
      true,
      () => {
        this.userService.resendInviteToUser(user.userId, () => {
          this.alertsAndNotificationsService.showBannerMessage('Invite sent to user successfully', 'success');
          this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }, (error) => {
          this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
          this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        });
      },
      () => { }
    );
  }

  getDeleteUserInfo(userId) {
    this.userService.getDeleteUserInfo(userId, (data) => {
      this.deletingUser.numberOfCandidates = data.numberOfCandidates;
      this.deletingUser.numberOfRequisitions = data.numberOfRequisitions;
      this.deletingUser.requisitionDetails = data.requisitionDetails;
      this.launchDeleteUserModal(() => {
        this.deleteUserCallback.emit();
        this.userService.userCache(null, () => { }, () => { });
      });
    }, (error) => {
      this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
    });
  }

  launchDeleteUserModal(deleteCallback) {
    const config = new ModalConfig();
    const modalData: any = {
      type: 'delete',
      title: 'Delete User',
      userInfo: this.deletingUser
    };
    config.class = 'modal-lg custom-ngx-modal';
    config.initialState = modalData;
    config.ignoreBackdropClick = true;
    this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    this.userCardActionsModal = this.modalService.show(UserCardActionsModalComponent, config);
    this.userCardActionsModal.content.onClose.subscribe(result => {
      if (result && result.callbackType === 'delete') {
        if (deleteCallback) {
          deleteCallback();
        }
      }
    });
  }

  makeEmployee(user) {
    if (user.reporteesCount > 0) {
      this.alertsAndNotificationsService.showAlertWithCallBack(
        'Make Employee',
        'There are other Users reporting to this User. Please re-assign or delete those Users before attempting to make this User an Employee.',
        'warning',
        () => {
          this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
        }
      );
    } else {
      const config = new ModalConfig();
      const modalData: any = {
        type: 'convertUserToEmployee',
        title: 'Make Employee',
        userId: user.userId
      };
      config.class = 'modal-lg custom-ngx-modal';
      config.initialState = modalData;
      config.ignoreBackdropClick = true;
      this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
      this.userCardActionsModal = this.modalService.show(UserCardActionsModalComponent, config);
      this.userCardActionsModal.content.onClose.subscribe(result => {
        if (result && result.callbackType === 'save') {
          const employeeObject = result.entity;
          let employeeName = employeeObject.firstName;
          employeeName = _.isNull(employeeObject.lastName)
            ? employeeName
            : employeeName + ' ' + employeeObject.lastName;
          // The reload can interrupt the modal's close, leaving its scroll lock on the body.
          this.$state.go('missioncontrol.employeeManagement',
            { employeeId: employeeObject.id, employeeName: employeeName },
            { reload: true }).then(() => {
              document.body.classList.remove('modal-open');
              document.body.style.paddingRight = '';
            });
        }
      });
    }
  }

  showRecentActivities() {
    this.recentActivitiesControls.activityClickCount++;
    this.isActivityClicked = !this.isActivityClicked;
  }

  showAllActivityModal() {
    const config = new ModalConfig();
    const modalData: any = {
      type: 'activities',
      title: 'Activities',
      userInfo: this.userInfo,
      context: 'user',
      activityMap: this.activityMap
    };
    config.class = 'custom-modal-xl custom-ngx-modal';
    config.initialState = modalData;
    this.angularModalService.addModalOpenClassToBodyIfAnyModalIsOpen();
    this.userCardActionsModal = this.modalService.show(UserCardActionsModalComponent, config);
  }

  cardMenuToggled(openFlag, id) {
    if (openFlag) {
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
      }, 200);
    }
  }

  toggleExpansion(user) {
    user.collapsed = !user.collapsed;
  }

  showAndHideUserScope() {
    this.showUserScope = !this.showUserScope;
    setTimeout(() => {
      this.isUserScope = this.showUserScope;
    }, 300);
  }

  _setClientOrBUList() {
    if (this.userInfo.userEntityScope && this.userInfo.userEntityScope.clientOrBUList) {
      this.clientOrBuList = this.userInfo.userEntityScope.clientOrBUList.filter(c => c.selected);
    } else {
      this.clientOrBuList = [];
    }
  }

  trackByUserId(index, user) {
    return user ? user.userId : index;
  }

  trackByIndex(index) {
    return index;
  }
}
